<template>
  <aside :class="['twcs-sticky twcs-overflow-y-auto twcs-transition-all twcs-duration-300', !isScrollingDown ? 'twcs-top-[14.5rem] twcs-max-h-screen--8' : 'twcs-top-4 twcs-max-h-screen--6']">
    <Transition
      enter-active-class="twcs-ease-in-out twcs-duration-200"
      enter-from-class="twcs-opacity-0"
      enter-to-class="twcs-opacity-100"
      leave-active-class="twcs-ease-in-out twcs-duration-200"
      leave-from-class="twcs-opacity-100"
      leave-to-class="twcs-opacity-0"
      mode="out-in"
    >
      <nav v-if="!filterSearchStore.searchData.navLoading" class="twcs-space-y-1 twcs-p-1">
        <!-- Current: "bg-gray-50 text-kctcs-navy-700 hover:text-kctcs-navy-700 hover:tbg-white", Default: "text-gray-900 hover:text-gray-900 hover:bg-gray-50" -->
        <!-- Current: "text-kctcs-navy-500 group-hover:text-kctcs-navy-500", Default: "text-gray-400 group-hover:text-gray-500" -->
        <a
          v-for="category in visibleCategories"
          :key="category.name"
          @click.prevent="onCategoryNavClick(category)"
          :class="[category.name === filterSearchStore.searchData.currentNav.name
          ? 'twcs-bg-gray-200 twcs-text-gray-900'
          : 'twcs-text-gray-600 hover:twcs-bg-gray-50 hover:twcs-text-gray-900 ',
          'twcs-group twcs-flex twcs-items-center twcs-px-2 twcs-py-2 twcs-text-base twcs-font-medium twcs-rounded-md']"
          href="#"
          :id="category.name.replace(/\s+/g, '-').toLowerCase()+'-nav'"
        >
          <span class="twcs-truncate">
            {{ category.name }}
          </span>

          <span
            class="twcs-bg-gray-100 twcs-ml-auto twcs-inline-block twcs-py-0.5 twcs-px-3 twcs-text-base twcs-font-medium twcs-rounded-full"
            :class="{ 'group-hover:twcs-bg-gray-100 twcs-bg-gray-200': category.name !== filterSearchStore.searchData.currentNav.name}"
          >
            {{ category.count }}
          </span>
        </a>
				<div v-if="visibleCategoriesCount < filterSearchStore.searchData.categories.length" class="twcs-flex twcs-justify-center">
					<button @click="onLoadMoreCategories()" class="twcs-bg-gray-200 twcs-text-gray-900 twcs-p-2 twcs-text-base twcs-font-medium twcs-rounded-md">
						Load more
					</button>
				</div>
      </nav>
      <div v-else class="twcs-p-7 twcs-bg-white">
        <div class="twcs-h-full">
          <div class="twcs-loader-animation twcs-relative twcs-overflow-hidden twcs-bg-gray-150" style="height: 13.5rem;">
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-twcs-top-2 twcs-twcs-bg-white twcs-h-4"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-top-6 twcs-bg-white twcs-h-2"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-top-8 twcs-bg-white twcs-h-4"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-top-12 twcs-bg-white twcs-h-2"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-top-14 twcs-bg-white twcs-h-6"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 5.5rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 6.5rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 7rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 8rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-6" style="top: 8.5rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 10.5rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 11.5rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 12rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 13rem;"></div>
          </div>
        </div>
      </div>
    </Transition>
  </aside>
</template>

<style>
  .animation {
    /* transform: translate3d(0, 0, 0); */
    transition: 0.1s all ease-out;
  }
</style>

<script setup>
import { ref, computed } from 'vue';
import Bugsnag from '@bugsnag/js';
import { useFilterSearchStore } from '@/stores/filter-search.js';
import { scrollToCategoryHeading } from '@/helpers/scroll-to-category.js';

let filterSearchStore = useFilterSearchStore();

defineProps({
	isScrollingDown: {
		type: Boolean,
		required: true,
	},
});

let visibleCategoriesCount = ref(10);

let visibleCategories = computed(() => {
	return filterSearchStore.searchData.categories.slice(0, visibleCategoriesCount.value);
});

function onLoadMoreCategories() {
	visibleCategoriesCount.value += 10;
}

async function onCategoryNavClick(category) {
	try {
		let completed = await filterSearchStore.navigateCategory(category);
		if (!completed) {
			return;
		}
		await scrollToCategoryHeading(category.name);
	} catch (err) {
		Bugsnag.notify(err);
	}
}
</script>
